import { render, staticRenderFns } from "./SOV2Detailed.vue?vue&type=template&id=15345b0a&scoped=true"
import script from "./SOV2Detailed.vue?vue&type=script&lang=js"
export * from "./SOV2Detailed.vue?vue&type=script&lang=js"
import style0 from "./SOV2Detailed.vue?vue&type=style&index=0&id=15345b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15345b0a",
  null
  
)

export default component.exports